/**
 * SCRUM-249 (WH-7) — Zod schema for the provider-managed config read endpoint
 * (DS-017 §12.1).
 *
 *   GET /organizations/:slug/properties/:propertyId/pricing/provider/preferences
 *       GetProviderManagedConfig (the greyed-out values the Strategy Grid displays)
 *
 * Money fields are integer Cents (NOT dollars) and nullable (null = unconfigured
 * by the provider). The controller serializes domain Cents → integer number via
 * the canonical centsToNumber helper (money-guardian convention). `weekendFactor`
 * is a plain multiplier (NOT money).
 *
 * NOTE: the use case returns `Result | null`; `null` (manual mode / cross-org
 * RLS miss) maps to HTTP 404 in the controller — this schema describes only the
 * 200 body (an integrated listing, whose individual fields may still be null
 * when the first ingest cycle has not landed).
 */
import { z } from 'zod';
import { centsSchema } from './_shared.js';
export const GetProviderManagedConfigResponseSchema = z.object({
    floorRateCents: centsSchema.nullable(),
    minMinRateCents: centsSchema.nullable(),
    maxRateCents: centsSchema.nullable(),
    baseRateCurrentCents: centsSchema.nullable(),
    weekendFactor: z.number().nonnegative().nullable(),
    minStayEnabled: z.boolean(),
    minMinStay: z.number().int().nonnegative().nullable(),
    automaticRatePosting: z.boolean(),
});
//# sourceMappingURL=provider-preferences.js.map